import { render, staticRenderFns } from "./WpRepoInstaller.vue?vue&type=template&id=1300d950&scoped=true&"
import script from "./WpRepoInstaller.vue?vue&type=script&lang=js&"
export * from "./WpRepoInstaller.vue?vue&type=script&lang=js&"
import style0 from "./WpRepoInstaller.vue?vue&type=style&index=0&id=1300d950&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1300d950",
  null
  
)

export default component.exports